import { dayjs } from '@/extendedDayjs';

/**
 * How long before its stated expiry an access token stops being worth using. Sized so a request that
 * starts just inside the window still finishes with a valid token.
 */
const TOKEN_REFRESH_BUFFER_SECONDS = 60;

export const tokenRefreshDueAt = (expiry: number) =>
    dayjs.unix(expiry).subtract(TOKEN_REFRESH_BUFFER_SECONDS, 'second');

export const isTokenRefreshDue = (expiry: number) => tokenRefreshDueAt(expiry).isBefore(dayjs());
